<template>
	<template v-if="isExpandable">
		<div
			v-if="text"
			data-type="richtext"
			class="ds-text-body-md ds-text--regular rich"
			:class="{ closed: !opened && isExpandable }"
		>
			<div v-html="props.text"></div>
			<DsButton variant="link" @click.prevent="toggle">{{ opened ? readLessLabel : readMoreLabel }}</DsButton>
		</div>
	</template>
	<template v-else>
		<div v-if="text" data-type="richtext" v-html="text" class="ds-text-body-md ds-text--regular"></div>
	</template>
</template>

<script setup lang="ts">
import { DsButton } from '@coloplast/design-system';
import { ref } from 'vue';

const props = defineProps({
	text: {
		type: String,
	},
	isExpandable: {
		type: Boolean,
	},
	readMoreLabel: {
		type: String,
	},
	readLessLabel: {
		type: String,
	},
});

const opened = ref(false);

function toggle() {
	opened.value = !opened.value;
}
</script>

<style lang="scss">
@import 'multisite/styles/settings/settings';
@import 'multisite/styles/tools/tools';

div[data-type='richtext'] {
	> div {
		max-height: 400px;
		overflow: hidden;
		transition: max-height t-duration('medium-2');
	}

	&.closed {
		> div {
			max-height: 50px;

			p {
				display: -webkit-box;
				animation: collapse;
				animation-duration: t-duration('medium-2');
				-webkit-line-clamp: 2;
				-webkit-box-orient: vertical;
				overflow: hidden;
			}
		}
	}

	> button.ds-button.ds-button--link {
		padding: 0;
		text-align: left;
		display: block;
		margin-top: 8px;

		&,
		&:hover,
		&:active {
			text-decoration: none;
		}
	}
}

@keyframes collapse {
	0% {
		-webkit-line-clamp: initial;
	}

	90% {
		-webkit-line-clamp: initial;
	}

	100% {
		-webkit-line-clamp: 2;
	}
}
</style>
